import { SidenavSection } from "../../parts/sidenav-nav.model";

/**
 * Central Support menu, rendered by `app-sidenav-group` inside the home view.
 * Add / remove / reorder items by editing this array — no markup changes needed.
 * All items route under the `central-support` segment.
 */
export const CENTRAL_SUPPORT_SECTIONS: SidenavSection[] = [
    {
        id: "support-tools",
        items: [
            { labelKey: "ADMIN.CENTRAL_SUPPORT.REVIEW_QUOTES", icon: "check-square", segments: ["central-support", "review-quotes"] },
        ],
    },
];
